/**
 * Locale cookie versioning.
 *
 * Bump LOCALE_COOKIE_VERSION whenever the detection logic changes and all
 * users should be re-evaluated against the new rules (geo + Accept-Language).
 * Cookies written with an older (or missing) version are treated as stale and
 * the locale is re-resolved from request signals.
 *
 * Format on the wire: "v{version}:{locale}"   e.g. "v1:nb-NO"
 * Legacy cookies (no prefix) are treated as version 0.
 */

export const LOCALE_COOKIE_VERSION = 1;

const VERSION_RE = /^v(\d+):(.+)$/;

export function encodeLocaleCookie(locale: string): string {
  return `v${LOCALE_COOKIE_VERSION}:${locale}`;
}

export function decodeLocaleCookie(
  raw: string,
): { locale: string; version: number } {
  const match = raw.match(VERSION_RE);
  if (match) {
    return { locale: match[2], version: parseInt(match[1], 10) };
  }
  return { locale: raw, version: 0 };
}

export function isLocaleCookieCurrent(raw: string): boolean {
  const { version } = decodeLocaleCookie(raw);
  return version >= LOCALE_COOKIE_VERSION;
}
